(()=>{
 const closeMenus=(except)=>document.querySelectorAll('.cro-nav details[open]').forEach(d=>{if(d!==except)d.open=false});
 document.addEventListener('toggle',e=>{if(e.target.matches('.cro-nav details')&&e.target.open)closeMenus(e.target)},true);
 document.addEventListener('click',e=>{if(!e.target.closest('.cro-nav'))closeMenus();const btn=e.target.closest('[data-cro-menu-tab]');if(btn){const menu=btn.closest('.cro-menu');menu.querySelectorAll('[data-cro-menu-tab]').forEach(b=>b.setAttribute('aria-pressed',b===btn?'true':'false'));menu.querySelectorAll('[data-cro-menu-panel]').forEach(p=>p.hidden=p.dataset.croMenuPanel!==btn.dataset.croMenuTab)}});
 document.addEventListener('keydown',e=>{if(e.key==='Escape'){const open=document.querySelector('.cro-nav details[open]');if(open){open.open=false;open.querySelector('summary').focus()}}});
 const hoverQuery=matchMedia('(min-width:990px) and (hover:hover) and (pointer:fine)');
 document.querySelectorAll('.cro-nav details').forEach(details=>{
  let openTimer,closeTimer;
  const summary=details.querySelector('summary');
  const open=()=>{if(!hoverQuery.matches)return;clearTimeout(closeTimer);openTimer=setTimeout(()=>{closeMenus(details);details.open=true},110)};
  const keep=()=>{clearTimeout(closeTimer)};
  const close=()=>{if(!hoverQuery.matches)return;clearTimeout(openTimer);closeTimer=setTimeout(()=>{details.open=false},220)};
  summary?.addEventListener('pointerenter',open);
  details.addEventListener('pointerenter',keep);
  details.addEventListener('pointerleave',close);
 });
 const dock=document.querySelector('[data-cro-buy-dock]');if(!dock)return;
 const update=()=>{const buy=document.querySelector('main product-form button[name=add]');if(!buy){dock.hidden=true;return}const b=buy.getBoundingClientRect();const modal=document.querySelector('#Details-menu-drawer-container[open],.header__search details[open],cart-drawer.active,#cart-notification.active,.tints-drop.is-visible,.product-media-modal[open]');dock.hidden=innerWidth>749||!!modal||(b.top>=0&&b.bottom<=innerHeight);const price=document.querySelector('main .price--on-sale .price-item--sale')||document.querySelector('main .price__regular .price-item');if(price)dock.querySelector('strong').textContent=price.textContent.trim()};
 let pending=false;const schedule=()=>{if(pending)return;pending=true;requestAnimationFrame(()=>{pending=false;update()})};
 document.addEventListener('scroll',schedule,{passive:true});window.addEventListener('resize',schedule);document.addEventListener('change',schedule);document.addEventListener('toggle',schedule,true);
 new MutationObserver(records=>{if(records.some(r=>!dock.contains(r.target)))schedule()}).observe(document.querySelector('main'),{subtree:true,childList:true,attributes:true,attributeFilter:['class','open','hidden']});
 dock.querySelector('button').addEventListener('click',()=>{const target=document.querySelector('main variant-selects')||document.querySelector('main product-form');if(!target)return;target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth',block:'center'});target.querySelector('input:not([type=hidden]),select,button')?.focus({preventScroll:true})});update();
})();

(()=>{
 const reduceMotion=matchMedia('(prefers-reduced-motion:reduce)');
 const cleanValue=(name,value)=>{
  const option=(name||'').toLowerCase();
  const selected=(value||'').trim();
  if(!selected||selected.toLowerCase()==='no')return '';
  if(option.includes('sticker')&&selected.toLowerCase()==='yes')return 'Sticker pack added';
  if(option.includes('allen')&&selected.toLowerCase()==='yes')return 'Allen key added';
  return selected.replace(/\s*\(type in box\)\s*/i,'');
 };
 const updateSummary=(box)=>{
  const values=[];
  box.querySelectorAll('[data-product-ux-option]').forEach(group=>{
   const name=group.dataset.productUxOption||'';
   const selected=group.querySelector('input[type=radio]:checked');
   const select=group.querySelector('select');
   const value=selected?.value||select?.value||'';
   const label=group.querySelector('[data-selected-value]');
   if(label)label.textContent=value;
   const cleaned=box.classList.contains('is-white-color-active')&&name.trim().toLowerCase()==='color'?'White':cleanValue(name,value);
   if(cleaned&&!values.includes(cleaned))values.push(cleaned);
  });
  const summary=box.querySelector('[data-product-ux-selected]');
  if(summary)summary.textContent=values.slice(0,3).join('  •  ');
 };
 const findCustomGroup=(box)=>{
  const input=[...box.querySelectorAll('input[type=text],textarea')]
   .find(field=>field.name?.startsWith('properties[')&&/custom\s*color/i.test(`${field.name} ${field.id} ${field.placeholder} ${field.getAttribute('aria-label')||''}`));
  if(!input)return null;
  return {input,group:input.closest('.tpo_option-label,.product-form__input,.field')||input.parentElement};
 };
 const setupFrameguard=(box)=>{
  if(box.dataset.productUxKind!=='frameguard')return;
  const slot=box.querySelector('[data-product-ux-custom-slot]');
  const custom=findCustomGroup(box);
  const getCustomChoice=()=>[...box.querySelectorAll('variant-selects input[type=radio]')]
   .find(input=>/custom\s*color/i.test(input.value));
  if(!slot||!custom||!getCustomChoice())return;
  const {input,group}=custom;
  const optionGroup=name=>[...box.querySelectorAll('variant-selects [data-product-ux-option]')]
   .find(candidate=>String(candidate.dataset.productUxOption||'').trim().toLowerCase()===name);
  const optionRadio=(name,value)=>[...(optionGroup(name)?.querySelectorAll('input[type=radio]')||[])]
   .find(candidate=>String(candidate.value||'').trim().toLowerCase()===value);
  const colorGroup=optionGroup('color');
  const blackChoice=optionRadio('color','black');
  let whiteChoice=colorGroup?.querySelector('[data-frameguard-white]');
  if(colorGroup&&blackChoice&&!whiteChoice){
   whiteChoice=document.createElement('button');
   whiteChoice.type='button';
   whiteChoice.className='product-ux__white-choice';
   whiteChoice.dataset.frameguardWhite='';
   whiteChoice.setAttribute('aria-pressed','false');
   whiteChoice.textContent='White';
   colorGroup.insertBefore(whiteChoice,blackChoice);
  }
  group.classList.add('product-ux__custom-color');
  if(group.parentElement!==slot)slot.append(group);
  const formId=slot.dataset.productFormId;
  if(formId)input.setAttribute('form',formId);
  input.placeholder='Example: Porsche Miami Blue or RAL 5012';
  const originalLabel=group.querySelector('.form__label,.tpo_option-label-container>span');
  if(originalLabel&&!originalLabel.dataset.productUxLabel){
   originalLabel.dataset.productUxLabel='true';
   originalLabel.classList.add('product-ux__custom-label');
   originalLabel.textContent='Tell us your custom color';
   const hint=document.createElement('small');
   hint.textContent='Use a paint code or describe the exact shade.';
   originalLabel.append(hint);
  }
  let error=group.querySelector('[data-product-ux-custom-error]');
  if(!error){
   error=document.createElement('p');
   error.className='product-ux__custom-error';
   error.dataset.productUxCustomError='';
   error.hidden=true;
   error.textContent='Enter the color you want before adding this custom item.';
   group.append(error);
  }
  const sync=()=>{
   const active=!!getCustomChoice()?.checked;
   const whiteActive=box.classList.contains('is-white-color-active');
   group.hidden=!active||whiteActive;
   input.disabled=!active;
   input.required=active;
   box.classList.toggle('is-custom-color-active',active);
   if(whiteChoice)whiteChoice.setAttribute('aria-pressed',String(whiteActive));
   if(!active)error.hidden=true;
   else if(!whiteActive&&!reduceMotion.matches)group.animate([{opacity:0,transform:'translateY(-6px)'},{opacity:1,transform:'translateY(0)'}],{duration:280,easing:'cubic-bezier(.2,.8,.2,1)'});
   updateSummary(box);
  };
  if(!group.dataset.productUxBound){
   group.dataset.productUxBound='true';
   input.addEventListener('input',()=>{if(input.value.trim())error.hidden=true});
   box.addEventListener('change',event=>{
    if(!event.target.matches('variant-selects input,variant-selects select'))return;
    if(event.target.matches('input[type=radio]')&&event.target!==getCustomChoice())box.classList.remove('is-white-color-active');
    sync();
   });
   box.addEventListener('click',event=>{
    const whiteButton=event.target.closest('[data-frameguard-white]');
    if(whiteButton){
     event.preventDefault();
     const customChoice=getCustomChoice();
     const gloss=optionRadio('topcoat','gloss');
     const returningToDefault=box.classList.contains('is-white-color-active');
     box.classList.toggle('is-white-color-active',!returningToDefault);
     input.value=returningToDefault?'':'White';
     if(gloss)gloss.checked=true;
     const next=returningToDefault?optionRadio('color','black'):customChoice;
     if(next){
      if(returningToDefault)next.click();
      else{
       next.checked=true;
       next.dispatchEvent(new Event('change',{bubbles:true}));
      }
     }
     sync();
     return;
    }
    const customLabel=event.target.closest('label.product-ux__custom-choice');
    const customChoice=getCustomChoice();
    if(customLabel&&customChoice?.checked&&box.classList.contains('is-white-color-active')){
     event.preventDefault();
     box.classList.remove('is-white-color-active');
     input.value='';
     sync();
     input.focus();
     return;
    }
    if(!customLabel||!customChoice?.checked)return;
    event.preventDefault();
    const black=optionRadio('color','black');
    const gloss=optionRadio('topcoat','gloss');
    if(!black)return;
    box.classList.remove('is-white-color-active');
    black.checked=true;
    if(gloss)gloss.checked=true;
    input.value='';
    black.dispatchEvent(new Event('change',{bubbles:true}));
    sync();
   });
   const form=document.getElementById(formId);
   form?.addEventListener('submit',event=>{
    if(!getCustomChoice()?.checked||input.value.trim())return;
    event.preventDefault();
    event.stopImmediatePropagation();
    error.hidden=false;
    group.hidden=false;
    input.focus();
    group.scrollIntoView({behavior:reduceMotion.matches?'auto':'smooth',block:'center'});
   },true);
  }
  sync();
 };
 const setupWheelChooser=(box)=>{
  const chooser=box.querySelector('[data-wheel-build-chooser]');
  const getFinishRoot=()=>box.querySelector('[data-wheel-product-finishes]');
  if(!chooser||!getFinishRoot())return;
  if(chooser.dataset.wheelBuildBound&&typeof chooser._syncWheelForm==='function'){chooser._syncWheelForm();return}
  chooser.dataset.wheelBuildBound='true';
  const normalize=value=>String(value||'').trim().toLowerCase();
  const optionPicker=()=>box.querySelector('variant-selects');
  const placeFinishControls=()=>{
   const finishRoot=getFinishRoot();
   const picker=optionPicker();
   if(!finishRoot||!picker)return;
   const form=finishRoot.closest('form[data-type="add-to-cart-form"]');
   // A product form contains an input named "id", which can shadow form.id.
   // Read the attribute directly so the moved finish fields stay associated
   // with the real add-to-cart form instead of "[object HTMLInputElement]".
   const formId=form?.getAttribute('id')||'';
   if(formId){finishRoot.dataset.productFormId=formId;finishRoot.querySelectorAll('[data-wheel-product-property]').forEach(input=>input.setAttribute('form',formId))}
   if(finishRoot.previousElementSibling!==picker)picker.insertAdjacentElement('afterend',finishRoot);
  };
  placeFinishControls();
  box.classList.add('is-wheel-chooser-ready');
  const optionGroups=()=>[...(optionPicker()?.querySelectorAll('[data-product-ux-option]')||[])];
  const optionGroup=part=>optionGroups()
   .find(group=>normalize(group.dataset.productUxOption).includes(part));
  const selectedValue=part=>optionGroup(part)?.querySelector('input[type=radio]:checked')?.value||optionGroup(part)?.querySelector('select')?.value||'';
  const spokeButtons=()=>[...box.querySelectorAll('[data-wheel-product-spoke]')];
  const selectedSpoke=()=>spokeButtons().find(button=>button.getAttribute('aria-checked')==='true')?.value||'';
  const customSelect=part=>getFinishRoot()?.querySelector(`[data-wheel-product-custom="${part}"]`);
  const syncWheelForm=()=>{
   const finishRoot=getFinishRoot();
   if(!finishRoot)return;
   let variants=[];
   try{variants=JSON.parse(finishRoot.querySelector('[data-wheel-product-variants]')?.textContent||'[]')}catch(parseError){variants=[]}
   const selectedOptions=optionGroups().map(group=>group.querySelector('input[type=radio]:checked')?.value||group.querySelector('select')?.value||'');
   const variant=variants.find(candidate=>candidate.options?.every((value,index)=>normalize(value)===normalize(selectedOptions[index])));
   const productForm=finishRoot.closest('form[data-type="add-to-cart-form"]')||document.getElementById(finishRoot.dataset.productFormId||'');
   if(variant)productForm?.querySelectorAll('input[name="id"]').forEach(input=>{input.value=variant.id;input.setAttribute('value',variant.id)});
   const rimVariant=selectedValue('rim');
   const hubVariant=selectedValue('hub');
   const isCustom=value=>normalize(value).startsWith('custom');
   const rim=isCustom(rimVariant)?customSelect('rim')?.value||'':rimVariant;
   const hub=isCustom(hubVariant)?customSelect('hub')?.value||'':hubVariant;
   const spoke=selectedSpoke();
   [['rim',rim],['hub',hub],['spoke',spoke]].forEach(([part,value])=>{
    const property=finishRoot.querySelector(`[data-wheel-product-property="${part}"]`);
    const summary=finishRoot.querySelector(`[data-wheel-product-summary="${part}"]`);
    if(property){property.value=value;property.setAttribute('value',value)}
    if(summary)summary.textContent=value||'Choose color';
   });
   const spokeLabel=finishRoot.querySelector('[data-wheel-spoke-selected]');
   if(spokeLabel)spokeLabel.textContent=spoke;
   [['rim',rimVariant],['hub',hubVariant]].forEach(([part,value])=>{
    const select=customSelect(part);
    const field=finishRoot.querySelector(`[data-wheel-custom-field="${part}"]`);
    const active=isCustom(value);
    if(field)field.hidden=!active;
    if(select){select.required=active;select.disabled=!active}
   });
  };
  chooser._syncWheelForm=syncWheelForm;
  const setSpoke=value=>{
   const target=spokeButtons().find(button=>normalize(button.value)===normalize(value));
   if(!target)return;
   spokeButtons().forEach(button=>button.setAttribute('aria-checked',button===target?'true':'false'));
   target.click();
  };
  const classify=()=>{
   const rim=normalize(selectedValue('rim'));
   const hub=normalize(selectedValue('hub'));
   const spoke=normalize(selectedSpoke());
   if(rim==='chrome'&&hub==='chrome'&&spoke.includes('chrome'))return 'chrome';
   if(rim==='black'&&hub==='black'&&spoke==='black')return 'black';
   return 'custom';
  };
  const updateStatus=(forced)=>{
   const state=forced||classify();
   chooser.querySelectorAll('[data-wheel-build-preset]').forEach(button=>button.setAttribute('aria-pressed',button.dataset.wheelBuildPreset===state?'true':'false'));
   const status=chooser.querySelector('[data-wheel-build-status]');
   if(status)status.textContent=state==='chrome'?chooser.dataset.statusChrome:state==='black'?chooser.dataset.statusBlack:state==='custom'?chooser.dataset.statusCustom:chooser.dataset.statusPrompt;
   chooser.dataset.wheelBuildState=state;
   const returns=box.querySelector('[data-wheel-return-note]');
   if(returns){
    const actualState=classify();
    returns.textContent=actualState==='chrome'||actualState==='black'?returns.dataset.stockLabel:returns.dataset.customLabel;
   }
   box.classList.toggle('is-wheel-mix-active',state==='custom'||state==='prompt');
  };
  const setVariantFinish=(part,value)=>{
   const group=optionGroup(part);
   const radio=[...(group?.querySelectorAll('input[type=radio]')||[])].find(input=>normalize(input.value)===normalize(value));
   if(radio)radio.checked=true;
   const select=group?.querySelector('select');
   if(select)select.value=value;
   return radio||select;
  };
  chooser.addEventListener('click',event=>{
   const button=event.target.closest('[data-wheel-build-preset]');
   if(!button)return;
   const preset=button.dataset.wheelBuildPreset;
   if(preset==='custom'){
    updateStatus('custom');
    const firstChoice=optionGroup('rim')?.querySelector('input[type=radio]:checked,select');
    firstChoice?.focus({preventScroll:true});
    chooser.classList.add('is-custom-intent');
    return;
   }
   chooser.classList.remove('is-custom-intent');
   const color=preset==='chrome'?'Chrome':'Black';
   setVariantFinish('rim',color);
   const finalControl=setVariantFinish('hub',color)||setVariantFinish('rim',color);
   setSpoke(preset==='chrome'?'Shiny chrome':'Black');
   finalControl?.dispatchEvent(new Event('change',{bubbles:true}));
   syncWheelForm();
   updateStatus(preset);
   if(!reduceMotion.matches)chooser.animate([{transform:'scale(.99)'},{transform:'scale(1.012)'},{transform:'scale(1)'}],{duration:420,easing:'cubic-bezier(.2,.8,.2,1)'});
   window.setTimeout(updateStatus,400);
  });
  box.addEventListener('change',()=>window.setTimeout(()=>{syncWheelForm();updateStatus()},0));
  box.addEventListener('click',event=>{if(event.target.closest('[data-wheel-product-spoke]'))window.setTimeout(()=>{syncWheelForm();updateStatus()},0)});
  box.addEventListener('submit',event=>{
   const finishRoot=getFinishRoot();
   const productForm=finishRoot?.closest('form[data-type="add-to-cart-form"]')||document.getElementById(finishRoot?.dataset.productFormId||'');
   if(!finishRoot||event.target!==productForm)return;
   syncWheelForm();
   const rimVariant=selectedValue('rim');
   const hubVariant=selectedValue('hub');
   const values={
    rim:isCustom(rimVariant)?customSelect('rim')?.value||'':rimVariant,
    hub:isCustom(hubVariant)?customSelect('hub')?.value||'':hubVariant,
    spoke:selectedSpoke()
   };
   const missingPart=Object.keys(values).find(part=>!values[part]);
   if(!missingPart)return;
   event.preventDefault();
   event.stopImmediatePropagation();
   const error=finishRoot.querySelector('[data-wheel-product-error]');
   if(error){error.hidden=false;error.textContent=`Please choose a ${missingPart.toUpperCase()} finish before adding this wheelset to cart.`}
   (customSelect(missingPart)||spokeButtons()[0])?.focus();
  },true);
  syncWheelForm();
  updateStatus();
 };
 const init=(scope=document)=>{
  const boxes=scope.matches?.('[data-product-ux-kind]')?[scope]:scope.querySelectorAll?.('[data-product-ux-kind]')||[];
  boxes.forEach(box=>{
   updateSummary(box);
   setupFrameguard(box);
   setupWheelChooser(box);
   if(box.dataset.productUxBound)return;
   box.dataset.productUxBound='true';
   box.addEventListener('change',()=>requestAnimationFrame(()=>updateSummary(box)));
  });
  window.CroUpdateAddonBadges?.(scope);
 };
 let queued=false;
 const schedule=()=>{if(queued)return;queued=true;requestAnimationFrame(()=>{queued=false;init()})};
 document.addEventListener('shopify:section:load',event=>init(event.target));
 new MutationObserver(schedule).observe(document.documentElement,{subtree:true,childList:true});
 init();
})();
